import './polyfill';
import sal from 'sal.js';
import objectFitImages from 'object-fit-images';
import ScrollTo from './modules/scroll-to';
import * as TextReveal from "./modules/text-reveal";
import { init as formsInit } from './modules/forms';

class App {
  constructor() {
    App.importComponents();
    App.addEventListeners();
    App.focusOutline();

    // If document already loaded, call init
    if (document.readyState !== 'loading') {
      App.init();
    }
  }

  static importComponents() {
    App.importAll(require.context('./components/', true, /\.js$/));
  }

  static importAll(r) {
    r.keys().forEach(r);
  }

  static addEventListeners() {
    document.addEventListener('initialised', App.init);
  }

  static focusOutline() {
    const noKeyboardClass = 'no-keyboard-navigation-in-use';

    // Add default class to html
    document.documentElement.classList.add(noKeyboardClass);

    // On keyboard use, remove class
    window.addEventListener('keydown', () => {
      document.documentElement.classList.remove(noKeyboardClass);
    });

    //  On click, add class
    window.addEventListener('click', () => {
      document.documentElement.classList.add(noKeyboardClass);
    });
  }

  static loadElements() {
    const images = [...document.querySelectorAll('wp-img')];

    images.forEach(el => {
      el.attach();
    });

    const lazySizes =
      'lazySizes' in window ? [...window.lazySizes.elements] : [];

    lazySizes.forEach(el => {
      window.lazySizes.loader.unveil(el);
    });
  }

  // Add any callbacks that need to run when content added to the page
  static init() {
    objectFitImages();
    formsInit();
    ScrollTo.init();
    sal({
      threshold: 0.1,
      rootMargin: "0px 0px -10px 0px"
    });
    TextReveal.init();
  }
}

new App();
